module.exports = __webpack_public_path__ + "static/media/double_caret_vertical.ad47581a.svg";